The list of advertisement products available to the hirer when posting or updating a job.

This query accepts browser tokens that include the `query:ad-products` scope.
